export const getTotalLoanAmount = (drawsEnabled: boolean, maxLineOfCredit: number, originalAmount: number): number =>
  drawsEnabled ? maxLineOfCredit : originalAmount;
